export interface SelectOption {
	value: number;
	text: string;
}
